import { FileUploadPhase, resolveFileUploadPhase } from '@sib/files';
import { useTranslation } from '@sib/i18n';
import { FileItem, FileStatus } from '@sib/types';

const UPLOAD_PHASE_I18N_KEYS: Record<FileUploadPhase, string> = {
  [FileUploadPhase.Processing]: 'fileManager.uploadPhases.processing',
  [FileUploadPhase.Waiting]: 'fileManager.uploadPhases.waiting',
  [FileUploadPhase.Uploading]: 'fileManager.uploadPhases.uploading',
  [FileUploadPhase.Complete]: 'fileManager.uploadPhases.complete',
};

export const useFileUploadItem = (fileItem: FileItem) => {
  const { t } = useTranslation();
  const isUploaded = fileItem.status === FileStatus.Uploaded;
  const isError = fileItem.status === FileStatus.Error;
  const isFileUploading = fileItem.status === FileStatus.Uploading;
  const isFileDownloadable = !!fileItem?.downloadUrl;

  const getUploadPhase = () => {
    const phase = resolveFileUploadPhase(fileItem);

    return phase ? t(UPLOAD_PHASE_I18N_KEYS[phase]) : '';
  };

  return {
    isUploaded,
    isError,
    isFileUploading,
    isFileDownloadable,
    getUploadPhase,
  };
};
